import React from 'react';
import VstComponent from './VstComponent';

class VstHamburger extends VstComponent {

  constructor() {
    super();
    this._clickHamburger = this._clickHamburger.bind(this);
  }

  _clickHamburger(e) {
    if (this.props.clickHamburger) {
      this.props.clickHamburger(e);
    }
  }

  render() {
    return (
      <button className="hamburger vst-no-button"
        onClick={this._clickHamburger}
        aria-expanded={this.props.active}
      >
        <span className="vst-off-screen">Hambuggler</span>
      </button>
    );
  }

}

export default VstHamburger;
